import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col, Modal, Spinner } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
import ZoneForm from './ZoneForm';
import { DELETE_ZONE, FETCH_ZONE, GET_ZONE } from 'actions/address';
import ReactPagination from 'components/general/ReactPagination';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';

const ZoneList = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [zoneId, setZoneId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [pageWiseZoneData, setPageWiseZoneData] = useState([]);

  const zoneList = useSelector((state) => state.zone.zones);
  const isLoader = useSelector((state) => state.zone.isLoading);
  const page = useSelector((state) => state.zone.page);
  const totalData = useSelector((state) => state.zone.total);
  const limit = useSelector((state) => state.zone.limit);
  const totalPages = useSelector((state) => state.zone.totalPages);

  const zoneData = zoneList.filter(({ id: id1 }) => pageWiseZoneData.some(({ id: id2 }) => id2 === id1));

  const getZone = useCallback(
    (data = {}) => {
      if (searchText) {
        const searchZoneData = {
          ...data,
          search: searchText,
        };
        dispatch({
          type: FETCH_ZONE.REQUEST,
          payload: searchZoneData,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                setPageWiseZoneData(res.data.results);
              }
            }
          },
        });
      } else {
        dispatch({
          type: FETCH_ZONE.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                setPageWiseZoneData(res.data.results);
              }
            }
          },
        });
      }
    },
    [pageWiseZoneData, searchText]
  );

  const getZoneDetail = useCallback((id) => {
    dispatch({ type: GET_ZONE.REQUEST, payload: id });
  }, []);

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setZoneId('');
  };

  const deleteZone = useCallback(
    () =>
      dispatch({
        type: DELETE_ZONE.REQUEST,
        payload: zoneId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getZone({ page: 1 });
          }
        },
      }),
    [zoneId]
  );

  useEffect(() => {
    getZone();
  }, []);

  const handleSearch = () => {
    getZone({});
  };

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getZone(data);
      }
    },
    [sortByItem]
  );

  const handleCloseFormZone = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getZone(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getZone(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title="Zones" />
        <div className="page-content-wrapper scrollable">
          <div className="countryList-page">
            <Card>
              <div className="countryList-page-wrapper">
                <Row className="countryList-search-box">
                  <Col xl={10} lg={9} md={8} className="countryList-search-inputBox">
                    <SearchBox
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                    />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="countryList-search-boxButton">
                    <Button
                      className="countryList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      Add Zone
                    </Button>
                  </Col>
                </Row>
                <div className="countryList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>Region Name</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Zone Name</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th className="action-col">
                            <span>Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoader ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(zoneData) ? (
                          <tr>
                            <td colSpan={6} className="border-0">
                              <div className="empty-data-block">No records found.</div>
                            </td>
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(zoneData, (item, key) => {
                            return (
                              <tr key={`zone-${key}`}>
                                <td>{_.get(item, 'region.name', '')}</td>
                                <td>{_.get(item, 'name')}</td>
                                <td>
                                  <span
                                    className="countryList-table-editIcon"
                                    onClick={() => {
                                      setShowForm(true);
                                      getZoneDetail(_.get(item, 'id'));
                                      setIsEdit(true);
                                    }}
                                  >
                                    <FiEdit2 title="Edit" />
                                  </span>
                                  <span
                                    className="countryList-table-deleteIcon"
                                    onClick={() => {
                                      setShowDeleteModal(true);
                                      setZoneId(_.get(item, 'id', ''));
                                    }}
                                  >
                                    <RiDeleteBinLine title="Delete" />
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                    {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(zoneData) && (
                      <ReactPagination
                        currentPage={page}
                        limit={limit}
                        total={totalData}
                        handlePageClick={(pageVal) => handlePageClick(pageVal)}
                        totalPages={totalPages}
                        marginPagesDisplayed={1}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered>
            <ZoneForm onClose={handleCloseFormZone} isEdit={isEdit} onSuccess={getZone} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="zone" onClose={handleCloseDeleteModel} onRemove={deleteZone} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};
export default ZoneList;
